import React from 'react';
import Spinner from '../../../../Utils/Spinner';
import placeholderImage from '../../../../../assets/images/image-placeholder.svg';
import giftIcon from '../../../../../assets/images/gift-grey.svg';

const getNumber = (text) => {
    const match = String(text).match(/\d+/);
    return match ? match[0] : '';
};

const ORDERABLE_TYPES = ['X', 'G', 'NP', 'B'];

// X - discount - Euro (points) / Amount (per_amount)
// G - gadget - text + promo (%)


const getPromoLabel = (product, weekData) => {
    if (!weekData) {
        return null;
    }

    if (weekData.promo_label) {
        return weekData.promo_label;
    }

    // X - discount - Euro (points) / Amount (per_amount)
    if (weekData.promo_type === 'X' && product.points && product.per_amount) {
        return `${product.points} ${'\u20AC'} / ${product.per_amount} ST`;
    }

    // Legacy: B used to represent discount
    if (
        weekData.promo_type === 'B' &&
        product.points &&
        product.per_amount
    ) {
        return `${'\u20AC'}${product.points} / ${product.per_amount}ST`;
    }

    if (
        (weekData.promo_type === 'G' || weekData.promo_type === 'NP') &&
        product.promo
    ) {
        return `${product.promo}%`;
    }

    return null;
};

const FairWeekInput = ({
    productItem,
    index,
    week,
    weeks,
    addProduct,
    setFairProducts,
    loadingState,
    pageSize,
    showProductGadget,
    onWeekFocus,
    onWeekBlur,
}) => {
    const weekData =
        productItem &&
        productItem.fair_product_promotions &&
        productItem.fair_product_promotions.find(
            (item) => item.week_date === week.week_date
        );

    const isOrderable =
        weekData && ORDERABLE_TYPES.includes(weekData.promo_type);

    const gadgetText = weekData
        ? weekData.promo_type === 'G' || weekData.promo_type === 'NP'
            ? weekData.gadget ||
                  weekData.label ||
                  (showProductGadget ? productItem.gadget : null)
            : null
        : showProductGadget
          ? productItem.gadget
          : null;

    if (!isOrderable) {
        return (
            <div className="fair-week-slot">
                <div className="fair-week-cell fair-week-cell--empty">
                    <img src={placeholderImage} alt="" />
                </div>
                {gadgetText ? (
                    <div className="fair-week-slot__gadget">
                        <img src={giftIcon} alt="" />
                        <span>{gadgetText}</span>
                    </div>
                ) : null}
            </div>
        );
    }

    const loadStateKey = `${productItem.product.id}-${week.week_date}`;
    const isLoading =
        loadingState &&
        Object.prototype.hasOwnProperty.call(loadingState, loadStateKey) &&
        loadingState[loadStateKey];
    const weekNumber = getNumber(week.week_name);
    const firstWeek = weeks[0];
    const lastWeek = weeks[weeks.length - 1];
    const promoLabel = getPromoLabel(productItem, weekData);
    const amountValue =
        weekData.amount === 0 || weekData.amount === '0' ? '' : weekData.amount;

    const handleKeyPress = (e) => {
        let keynum;

        if (window.e) {
            keynum = e.keyCode;
        } else if (e.which) {
            keynum = e.which;
        }

        if (keynum < 48 || keynum > 57) {
            e.preventDefault();
        }

        if (keynum === 13) {
            const nextInputId =
                week.week_name === lastWeek.week_name
                    ? `${index + 1}-${getNumber(firstWeek.week_name)}`
                    : `${index}-${parseInt(weekNumber, 10) + 1}`;
            const nextInput = document.getElementById(nextInputId);

            if (
                !(
                    pageSize === index + 1 &&
                    week.week_name === lastWeek.week_name
                ) &&
                nextInput
            ) {
                nextInput.focus();
            }
        }
    };

    return (
        <div className="fair-week-slot">
            <div
                className={`fair-week-cell ${
                    promoLabel ? 'fair-week-cell--promo' : ''
                }`}
            >
                {promoLabel && (
                    <span className="fair-week-cell__promo">{promoLabel}</span>
                )}
                {isLoading && (
                    <span className="fair-week-cell__spinner">
                        <Spinner width={13} height={13} />
                    </span>
                )}
                <input
                    disabled={isLoading}
                    id={`${index}-${weekNumber}`}
                    className="fair-week-cell__field"
                    value={
                        amountValue === null || amountValue === undefined
                            ? ''
                            : amountValue
                    }
                    type="text"
                    onKeyPress={handleKeyPress}
                    onFocus={() => onWeekFocus && onWeekFocus(week.week_date)}
                    onBlur={(e) => {
                        if (onWeekBlur) {
                            onWeekBlur();
                        }
                        addProduct(
                            week.week_date,
                            productItem.product.id,
                            e.target.value
                        );
                    }}
                    onChange={(e) => {
                        weekData.amount =
                            e.target.value === '' ? '' : Number(e.target.value);
                        setFairProducts(productItem);
                    }}
                />
            </div>
            {gadgetText ? (
                <div className="fair-week-slot__gadget">
                    <img src={giftIcon} alt="" />
                    <span>{gadgetText}</span>
                </div>
            ) : null}
        </div>
    );
};

export default FairWeekInput;
